import React from 'react'
import { SocketContext } from './socketContext'

export const useSocket = () => {
  const context = React.useContext(SocketContext)

  if (context === undefined) {
    throw new Error('useSocket can only be used within a Socket context')
  }

  return context
}

export default useSocket
